<template>
  <div
    :class="$style.contextMenu"
    :style="{ left: mouseX + 'px', top: mouseY + 'px' }"
  >
    <div :class="$style.label">
      {{ label || $t('common.moveTo') }}
    </div>
    <div
      v-for="group in groups"
      :key="group.id"
      :class="[$style.link, { [$style.eventsNone]: group.isEventsNone }]"
      @click="move(group)"
    >
      {{ getLabel(group.groupName) }}
    </div>
  </div>
</template>

<script>
  import { changeGroup } from '@/api/methods/categories';
  import { getLabel } from '@/helpers/fields';

  export default {
    props: ['mouseX', 'mouseY', 'groups', 'itemId', 'label'],
    methods: {
      getLabel(name) {
        return getLabel(name);
      },
      async move(group) {
        if (this.label) {
          this.$emit('action', group.id);
        } else {
          await changeGroup(this.itemId, group.id);
          this.$store.dispatch('settings/refresh');
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .contextMenu {
    box-shadow: 4px 6px 14px rgba(165, 165, 165, 0.4);
    position: absolute;
    background-color: white;
    width: 244px;
    padding: 10px;
    z-index: 4;
  }

  .link {
    text-decoration: none;
    display: block;
    padding: 3px;
    color: #4b4b4b;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      background: $borderColor;
    }
  }

  .eventsNone {
    pointer-events: none;
  }

  .label {
    display: block;
    padding: 3px;
    color: #4b4b4b;
    font-size: 14px;
    font-weight: 500;
    cursor: default;
  }
</style>
